import { useEffect, useRef } from "react";
import { initConnection } from "@/api/connection";
import { useNavigate } from "react-router-dom";

export const SalesforceCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const hasRun = useRef(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");
    const state = urlParams.get("state");
    const storedState = sessionStorage.getItem("sf_oauth_state");
    const codeVerifier = sessionStorage.getItem("sf_pkce_verifier");

    if (!code || !state || !storedState || !codeVerifier) {
      console.error("Missing required OAuth parameters");
      return;
    }

    if (state !== storedState) {
      console.error("Invalid state parameter");
      return;
    }

    initConnection({
      provider: "SALESFORCE",
      code,
      codeVerifier,
      state,
    })
      .then(() => {
        navigate("/integrations");
      })
      .catch((error) => {
        console.error("Error processing OAuth callback:", error);
        alert("Failed to connect to Salesforce. Please try again.");
      })
      .finally(() => {
        sessionStorage.removeItem("sf_oauth_state");
        sessionStorage.removeItem("sf_pkce_verifier");
      });
  }, [navigate]);

  return (
    <div className="callback-container">
      <h1>Processing OAuth Callback...</h1>
      <p>Please wait while we complete the connection to Salesforce.</p>
    </div>
  );
};
